

























import { Component, Vue } from 'vue-property-decorator';
import SubUnitNew from '@/components/SubUnit/SubUnitNew.vue';

@Component({
  components: {
    SubUnitNew,
  },
})
export default class SubUnitNewButton extends Vue {
  private showDialog = false;
}
